import React from 'react';

/**
 * Travel/preferences illustration icon (Undraw-style), used on the
 * Preferences screen. Simple flat-style SVG placeholder — replace with the
 * real Undraw illustration asset if/when one is added to the project.
 */
const UndrawTravelPlansIcon = ({ width = 120, height = 96 }) => (
  <svg width={width} height={height} viewBox="0 0 120 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="60" cy="84" rx="46" ry="6" fill="#f1f5f9" />
    <path d="M60 14c-12 0-20 9-20 20 0 15 20 38 20 38s20-23 20-38c0-11-8-20-20-20z" fill="#e53935" />
    <circle cx="60" cy="34" r="9" fill="#fff5f5" />
    <path d="M18 60l14-6 6 8-12 10-8-12z" fill="#ff7043" />
    <path d="M102 60l-14-6-6 8 12 10 8-12z" fill="#fdd835" />
  </svg>
);

export default UndrawTravelPlansIcon;
